const isArray = Array.isArray
export default isArray
